(ns frontend.test.survey.sub
  (:require [common.schema.data-types :as data-types]
            [re-frame.core :as rf]))

;; Available currency(-ies) is burned to the process when process is initialized.

(rf/reg-sub
 ::survey-configuration
 (fn []
   {:db/id                1704067199991
    :survey-target-name   "Company X"
    :identified-user-name "jaakko.pontinen@email.email"
    :reference-period     {:start-ts 1704067200000
                           :end-ts   1711889999000}
    :saved-series         {0 {0 true}}
    :multi-survey?        false
    :hide-no-answer?      true
    :excel-info-show?     false
    :pin-to-top-count     0
    :languages            #{:ENG :FIN}
    :label                {:ENG "Reporting label"
                           :FIN "Raporting otsikko"}
    :blocks               [{:block-type :survey-block/wysiwyg
                            :content    {:ENG "<strong>Lirum larum</strong>"
                                         :FIN "<strong>Lirum larum</strong>"}}
                           {:block-type      :survey-block/table-block
                            :localized-label "Income statement"
                            :label           {:ENG "Income statement"
                                              :FIN "Income statement"}
                            :columns         [{:start-ts 1704067200000
                                               :end-ts   1711889999000
                                               :label    "1.1 - 31.3.2024"
                                               :heading  "Q1"}
                                              {:start-ts 1704067200000
                                               :end-ts   1735689599000
                                               :label    "1.1 - 31.12.2024"
                                               :heading  "Year 2024"}]
                            :content
                            [{:survey-question/label-translations {:ENG "Revenue",
                                                                   :FIN "Kokonaisliikevaihto"},
                              :survey-question/info-translations  {:ENG "<p>Group's total net sales during the reporting period.</p>"
                                                                   :FIN "<p>Konsernin kokonaismyynti raportointijakson aikana.</p>"}
                              :survey-item-type                   :survey-item/question
                              :mandatoriness                      :mandatory/always
                              :cannot-skip?                       true
                              :show-mandatoriness?                false
                              :survey-question-id                 1011
                              :survey-question/data-type          :data.type/currency-value
                              :survey-question/data-unit          "Euro"
                              :visibility                         :visibility/always}
                             {:survey-question/label-translations {:ENG "EBITDA",
                                                                   :FIN "EBITDA"},
                              :survey-question/info-translations  {:ENG "<p>.</p>"
                                                                   :FIN "<p>.</p>"}
                              :survey-item-type                   :survey-item/question
                              :mandatoriness                      :mandatory/always
                              :cannot-skip?                       true
                              :show-mandatoriness?                false
                              :survey-question-id                 1012
                              :survey-question/data-type          :data.type/currency-value
                              :survey-question/data-unit          "Euro"
                              :visibility                         :visibility/always}]}
                           {:block-type      :survey-block/table-block
                            :resolved-label  "Balance sheet"
                            :label           {:ENG "Balance sheet"
                                              :FIN "Balance sheet"}
                            :snapshot-data?  true
                            :historical-data {:monthly [{:end-ts 1711889999000}]}
                            :forecast-data   {}
                            :data            [{:id           2011
                                               :question     "Junior loans"
                                               :label        "Junior loans"
                                               :data-type    (data-types/number-id-by-data-type :data.type/currency-value)
                                               :column-count 1
                                               :resp-0       125}
                                              {:id           2012
                                               :question     "Senior loans"
                                               :label        "Senior loans"
                                               :data-type    (data-types/number-id-by-data-type :data.type/currency-value)
                                               :column-count 1
                                               :resp-0       126}
                                              {:id           2013
                                               :question     "Capital loans"
                                               :label        "Capital loans"
                                               :data-type    (data-types/number-id-by-data-type :data.type/currency-value)
                                               :column-count 1
                                               :resp-0       127}
                                              {:id           2014
                                               :question     "Convertible bonds"
                                               :label        "Convertible bonds"
                                               :data-type    (data-types/number-id-by-data-type :data.type/currency-value)
                                               :column-count 1
                                               :resp-0       128}
                                              {:id           2015
                                               :question     "Cash & cash equivalents"
                                               :label        "Cash & cash equivalents"
                                               :data-type    (data-types/number-id-by-data-type :data.type/currency-value)
                                               :column-count 1
                                               :resp-0       129}]
                            :columns         [{:start-ts 1704067200000
                                               :end-ts   1711889999000
                                               :label    "1.1 - 31.3.2024"
                                               :heading  "Q1"}]
                            :content
                            [{:survey-question/label-translations {:ENG "Junior loans",
                                                                   :FIN "Junior loans"},
                              :survey-question/info-translations  {:ENG "<p>XXX.</p>"
                                                                   :FIN "<p>XXX.</p>"}
                              :survey-item-type                   :survey-item/question
                              :mandatoriness                      :mandatory/always
                              :cannot-skip?                       true
                              :show-mandatoriness?                false
                              :survey-question-id                 2011
                              :survey-question/data-type          :data.type/currency-value
                              :survey-question/data-unit          "Euro"
                              :visibility                         :visibility/always}
                             {:survey-question/label-translations {:ENG "Senior loans",
                                                                   :FIN "Senior loans"},
                              :survey-question/info-translations  {:ENG "<p>XXX.</p>"
                                                                   :FIN "<p>XXX.</p>"}
                              :survey-item-type                   :survey-item/question
                              :mandatoriness                      :mandatory/always
                              :cannot-skip?                       true
                              :show-mandatoriness?                false
                              :survey-question-id                 2012
                              :survey-question/data-type          :data.type/currency-value
                              :survey-question/data-unit          "Euro"
                              :visibility                         :visibility/always}
                             {:survey-question/label-translations {:ENG "Capital loans",
                                                                   :FIN "Capital loans"},
                              :survey-question/info-translations  {:ENG "<p>XXX.</p>"
                                                                   :FIN "<p>XXX.</p>"}
                              :survey-item-type                   :survey-item/question
                              :mandatoriness                      :mandatory/always
                              :cannot-skip?                       true
                              :show-mandatoriness?                false
                              :survey-question-id                 2013
                              :survey-question/data-type          :data.type/currency-value
                              :survey-question/data-unit          "Euro"
                              :visibility                         :visibility/always}
                             {:survey-question/label-translations {:ENG "Convertible bonds",
                                                                   :FIN "Convertible bonds"},
                              :survey-question/info-translations  {:ENG "<p>XXX.</p>"
                                                                   :FIN "<p>XXX.</p>"}
                              :survey-item-type                   :survey-item/question
                              :mandatoriness                      :mandatory/always
                              :cannot-skip?                       true
                              :show-mandatoriness?                false
                              :survey-question-id                 2014
                              :survey-question/data-type          :data.type/currency-value
                              :survey-question/data-unit          "Euro"
                              :visibility                         :visibility/always}
                             {:survey-question/label-translations {:ENG "Cash & cash equivalents",
                                                                   :FIN "Cash & cash equivalents"},
                              :survey-question/info-translations  {:ENG "<p>XXX.</p>"
                                                                   :FIN "<p>XXX.</p>"}
                              :survey-item-type                   :survey-item/question
                              :mandatoriness                      :mandatory/always
                              :cannot-skip?                       true
                              :show-mandatoriness?                false
                              :survey-question-id                 2015
                              :survey-question/data-type          :data.type/currency-value
                              :survey-question/data-unit          "Euro"
                              :visibility                         :visibility/always}]}]}))
